"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.blob_to_string = exports.sort_by_name = exports.safe_assign = exports.filter_keys = void 0;
function filter_keys(data, include_keys) {
    var e_1, _a;
    var result = {};
    try {
        for (var include_keys_1 = __values(include_keys), include_keys_1_1 = include_keys_1.next(); !include_keys_1_1.done; include_keys_1_1 = include_keys_1.next()) {
            var key = include_keys_1_1.value;
            result[key] = data[key];
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (include_keys_1_1 && !include_keys_1_1.done && (_a = include_keys_1.return)) _a.call(include_keys_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return result;
}
exports.filter_keys = filter_keys;
// A wrapper around Object.assign that adds type checking to enforce
// that "to" is a derived class of "from".
// Also limits "from" to a single value.
// BEWARE: TYPESCRIPT HAS COVARIANT ARRAYS. You may need to add a private member variable
// to your classes if you want them to behave like nominal types. For example:
//      class Spam {
//          private _spam_brand: unknown;
//      }
function safe_assign(to, from) {
    Object.assign(to, from);
}
exports.safe_assign = safe_assign;
// Sorts the given array in place by the "name" attribute of its elements.
function sort_by_name(to_sort) {
    to_sort.sort(function (first, second) { return first.name.localeCompare(second.name); });
}
exports.sort_by_name = sort_by_name;
function blob_to_string(blob) {
    var reader = new FileReader();
    return new Promise(function (resolve, reject) {
        reader.onload = function () {
            resolve(reader.result);
        };
        /* istanbul ignore next */
        reader.onerror = function () {
            reader.abort();
            reject(new DOMException("Error converting blob to string."));
        };
        reader.readAsText(blob);
    });
}
exports.blob_to_string = blob_to_string;
//# sourceMappingURL=utils.js.map